// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Input, Loader, Toastr, Button, Label } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../../../commonComponents";

// Actions Imports
import { UserActions } from "../../../../actions";

// Internal Imports
import { GlobalUtils } from "../../../../utils";
import { USER_ROLES } from "../../../../constants/roleList";
import { getAccountSettingsService } from "../../../../actions/SettingsActions/settingsService";

// Destructuring
const {
  addValueAndLabelPropsForSelectOptions,
  validateEmail,
  readDataFromLocalStorage,
  copyToClipBoard,
} = GlobalUtils;
const { editInviteUsers, inviteUsers, getAllTeammatesUsers } = UserActions;

class ManageTeammatesPopup extends Component {
  state = {
    inviteEmail: "",
    userRole: {},
    groupIds: [],
    errMsg: "",
    btnLoader: false,
    isUpdate: false,
    checkTeammate: null,
    resetUserRole: false,
    inviteCode: "",
    textToCopy: "",
    buttonText: "Copy Link",
    emailArray: [],
  };

  componentDidMount() {
    document.querySelector(".focus").focus();
    const urlPrefix = process.env.REACT_APP_DOMAIN_NAME;
    let { inviteCode } = this.state;
    if (inviteCode === "") {
      this.setState({
        btnLoader: true,
      });
      getAccountSettingsService().then(response => {
        inviteCode = response.Settings.invite_code;

        this.setState({
          inviteCode,
          textToCopy: `${urlPrefix}/welcome/`,
          btnLoader: false,
        });
      });
    }

    const { teammate } = this.props;

    // if it is an edit teammate case then,
    // prefield the required fields
    if (teammate && teammate.id) {
      const { roles, usergroups, user_email: inviteEmail } = teammate;
      let userRole = {};
      let groupIds = [];
      if (roles.length > 0) {
        userRole = {
          id: roles[0].id,
          label: roles[0].name,
          value: roles[0].name,
        };
      }
      if (usergroups.length > 0) {
        groupIds = usergroups.map(usergroup => ({
          id: usergroup.id,
          label: usergroup.name,
          value: usergroup.name,
        }));
      }
      this.setState({
        isUpdate: true,
        inviteEmail,
        userRole,
        groupIds,
      });
    } else {
      const accountOwnerRole = this._getAccountOwnerRole();
      if (accountOwnerRole) {
        this.setState({
          userRole: {
            id: accountOwnerRole.id,
            value: accountOwnerRole.name,
            label: accountOwnerRole.name,
          },
        });
      }
    }
  }

  _getAccountOwnerRole = () => {
    const accountOwnerRole = this.props.roles.filter(
      role => role.name === USER_ROLES.ADMIN,
    );
    console.debug("accountOwnerRole", accountOwnerRole);
    if (accountOwnerRole && accountOwnerRole.length > 0) {
      return accountOwnerRole[0];
    }
    return null;
  };

  _onInputChange = e => {
    let trimedValue = e.target.value;
    if (trimedValue) {
      trimedValue = trimedValue.trim().toLocaleLowerCase();
    }
    const { resetUserRole, userRole } = this.state;
    this.setState({
      [e.target.name]: trimedValue,
      errMsg: "",
      checkTeammate: null,
      userRole: resetUserRole ? {} : userRole,
      resetUserRole: false,
    });
  };

  _checkInviteEmail = e => {
    e.preventDefault();
    const { inviteEmail } = this.state;

    if (inviteEmail) {
      const checkTeammate = this.props.teammatesList.find(
        teammate => teammate.user_email === inviteEmail,
      );
      if (checkTeammate) {
        const { roles, usergroups } = checkTeammate;
        let userRole = {};
        let groupIds = [];
        if (roles.length > 0) {
          userRole = {
            id: roles[0].id,
            label: roles[0].name,
            value: roles[0].name,
          };
        }
        if (usergroups.length > 0) {
          groupIds = usergroups.map(usergroup => ({
            id: usergroup.id,
            label: usergroup.name,
            value: usergroup.name,
          }));
        }
        this.setState({
          checkTeammate,
          inviteEmail,
          userRole,
          groupIds,
          resetUserRole: true,
        });
      }
    }
  };

  _onSelectChange = (field, value) => {
    this.setState({ [field]: value });
  };

  _handleInviteSubmit = () => {
    const { inviteEmail, isUpdate, checkTeammate } = this.state;
    const { emailArray } = this.state;
    if (inviteEmail) {
      if (!emailArray.includes(inviteEmail)) {
        emailArray.push(inviteEmail);
        this.setState({
          inviteEmail: "",
        });
      }
    }

    if (!inviteEmail && !emailArray.length) {
      this.setState({
        errMsg: "Enter at least one valid email address",
      });
    }
    const payload = this._getInviteTeammatePayload(emailArray);
    if (Object.keys(payload).length > 0) {
      const isInviteOrReInviteCase = !!checkTeammate;
      this.setState({
        errMsg: "",
        btnLoader: true,
      });
      let submitInvite = this.props.inviteUsers;
      if (isUpdate) {
        submitInvite = this.props.editInviteUsers;
      }
      submitInvite(payload, isInviteOrReInviteCase)
        .then(() => {
          Toastr.showToastr({
            className: "is-success",
            message: isUpdate
              ? "Successfully edited teammate's details"
              : "Invitation email to join Revv sent to receiver",
            timeout: 2000,
          });
          this.setState({ btnLoader: false });
          this._closePopup();
        })
        .catch(error => {
          console.error(
            `ManageTeammatesPopup => _handleInviteSubmit => submitInvite => ${error}`,
          );
          let errorMsg = "Something went wrong..!!";
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.length > 0
          ) {
            const [tempError] = error.response.data.errors;
            if (tempError && tempError.Error && tempError.Error.message) {
              errorMsg = tempError.Error.message;
            }
          }
          this.setState({
            btnLoader: false,
            errMsg: errorMsg,
          });
        });
    }
  };

  _getInviteTeammatePayload = email => {
    const {
      inviteEmail,
      userRole,
      groupIds,
      isUpdate,
      checkTeammate,
    } = this.state;
    const { teammate } = this.props;

    let payload = [];
    let emailList = [];
    for (let i = 0; i < email.length; i += 1) {
      if (!validateEmail(email[i])) {
        this.setState({
          errMsg: `You have entered an invalid email id, please recheck`,
          btnLoader: false,
        });
        emailList = [];
        break;
      } else {
        emailList.push({
          user_email: email[i],
          roles: [{ id: userRole.id }],
          usergroups: groupIds.map(groupId => ({
            id: groupId.id,
          })),
        });
      }
    }

    let user;
    if (teammate && teammate.id) {
      user = teammate;
    } else if (checkTeammate) {
      user = checkTeammate;
    }
    if (user) {
      /**
       * If it is an edit invite or existing invite/re-invite user case then,
       * pass the two fields 'is_role_updated'
       * and 'is_usergroup_updated' along with user data
       */
      const {
        isRoleUpdated,
        isUserGroupsUpdated,
      } = this._checkRoleAndGroupChange(user);

      // for existing invite/re-invite
      payload = emailList;

      // for edit invite
      if (isUpdate) {
        const data = {
          user_email: inviteEmail,
          roles: [{ id: userRole.id }],
          usergroups: groupIds.map(groupId => ({
            id: groupId.id,
          })),
        };

        payload = {
          user: {
            ...data,
            id: teammate.id,
          },
          is_role_updated: isRoleUpdated,
          is_usergroup_updated: isUserGroupsUpdated,
        };
      }
    }
    // New invite
    else {
      payload = emailList;
    }
    return payload;
  };

  _checkRoleAndGroupChange = teammate => {
    const { userRole, groupIds } = this.state;
    const { roles, usergroups } = teammate;
    let isRoleUpdated = false;
    let isUserGroupsUpdated = false;
    if (roles && roles.length > 0 && roles[0].id !== userRole.id) {
      isRoleUpdated = true;
    }
    if (usergroups && usergroups.length !== groupIds.length) {
      isUserGroupsUpdated = true;
    } else {
      const gIds = groupIds.map(gid => gid.id);
      const ugIds = usergroups.map(ugid => ugid.id);
      gIds.forEach(gid => {
        if (!ugIds.includes(gid)) {
          isUserGroupsUpdated = true;
        }
      });
    }
    return {
      isRoleUpdated,
      isUserGroupsUpdated,
    };
  };

  _getUserGroupOptions = () => {
    const { userGroups } = this.props;
    return userGroups.map(userGroup => ({
      label: userGroup.name,
      value: userGroup.id,
    }));
  };

  _closePopup = () => {
    this.props.closePopup("showManageTeammatePopup", false, "editTeammate", {});
  };

  _submitBtnText = () => {
    const { checkTeammate, isUpdate } = this.state;
    let btnText = "Send Invite";
    if (isUpdate) {
      btnText = "Update";
    } else if (checkTeammate) {
      if (checkTeammate.is_invited) {
        btnText = "Invite";
      }
    }
    return btnText;
  };

  _existingTeammateMsg = () => {
    const { checkTeammate } = this.state;
    let msg =
      "This user is not yet invited to Revv, invite the user from here.";
    if (checkTeammate.is_confirmed) {
      const currentUser = readDataFromLocalStorage("revvsalesUser");
      if (
        currentUser &&
        currentUser.id === checkTeammate.id &&
        currentUser.user_email === checkTeammate.user_email
      ) {
        msg =
          "Please enter another email id as this is already registered within this organization.";
      } else {
        msg = "This user has already accepted the invitation.";
      }
    } else if (checkTeammate.is_invited) {
      msg = "This user has already been invited. You can re-invite from here.";
    } else if (checkTeammate.is_external) {
      msg = "";
    }
    return msg;
  };

  _disableRoleSection = () => {
    const currentUser = readDataFromLocalStorage("revvsalesUser");
    if (currentUser.id === this.props.teammate.id) {
      return true;
    }
    return false;
  };

  _CopyTextToClipboard = () => {
    const copiedData = copyToClipBoard(
      this.state.textToCopy + this.state.inviteCode,
    );
    if (copiedData) {
      Toastr.showToastr({
        type: "success",
        message: "Invite link copied to clipboard.",
        timeout: 3000,
      });
      this.setState({
        buttonText: "Copied",
      });
    } else {
      Toastr.showToastr({
        type: "warning",
        message:
          "Could not copy invite link. Please highlight and select link and copy to clipboard.",
        timeout: 3000,
      });
    }
  };

  _handleKeyDown = evt => {
    if (evt.key === " " || evt.key === "Enter") {
      const value = this.state.inviteEmail.trim();
      if (value && !this.state.emailArray.includes(value)) {
        if (!validateEmail(value)) {
          this.setState({
            errMsg: "You have entered an invalid email id, please recheck",
          });
        } else {
          this.state.emailArray.push(this.state.inviteEmail);
          this.setState({
            inviteEmail: "",
            errMsg: "",
          });
        }
      } else {
        this.setState({
          errMsg: "email already present in the list",
        });
      }
    }
  };

  _handleDelete = email => {
    const { emailArray } = this.state;
    for (let i = 0; i < emailArray.length; i += 1) {
      if (emailArray[i] === email) {
        emailArray.splice(i, 1);
      }
    }
    this.setState({
      emailArray,
    });
  };

  _handleEmailInput = () => {
    document.getElementById("myEmailInput").focus();
    return false;
  };

  render() {
    const {
      errMsg,
      groupIds,
      isUpdate,
      userRole,
      inviteEmail,
      checkTeammate,
    } = this.state;
    const errMsgSpace = errMsg ? (
      <div className="error-message-wrapper">{errMsg}</div>
    ) : null;
    const inviteMsgSpace =
      checkTeammate && this._existingTeammateMsg() ? (
        <div
          className={
            checkTeammate.is_confirmed
              ? "error-message-wrapper"
              : "teammatecard-info-message"
          }>
          {this._existingTeammateMsg()}
        </div>
      ) : null;

    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        {(this.state.btnLoader || this.props.externalLoader) && (
          <Loader className="loader-bg-color" label="Please wait..." />
        )}

        <div className="inviteteammatespopup-wrapper">
          <div className="inviteteammatespopup-modal-heading">
            {isUpdate ? "Edit teammate" : "Create your team for free"}
          </div>
          {inviteMsgSpace}
          {errMsgSpace}

          {!isUpdate && (
            <div className="inviteteammatespopup-description-section">
              <span className="inviteteammatespopup-description-text">
                Adding team members to Revv makes it easier to collaborate on
                documents and folders
              </span>
            </div>
          )}

          <div className="inviteteammatespopup-form">
            {this.state.inviteCode && !isUpdate ? (
              <div className="form-group">
                <Label htmlFor="userEmail">
                  Share the link below with team members to invite them
                </Label>
                <div className="inviteteammatespopup-copyblock">
                  <Input
                    className="copy-invite-text"
                    type="text"
                    readOnly="readonly"
                    value={this.state.textToCopy + this.state.inviteCode}
                    disabled="false"
                  />
                  <Button
                    data-test="copy-invite-code"
                    type="button"
                    className="btn btn-primary copy-button"
                    onClick={this._CopyTextToClipboard}>
                    {this.state.buttonText}
                  </Button>
                </div>
              </div>
            ) : null}

            <div className="inviteteammatespopup-form-field">
              <Label htmlFor="userEmail">
                {isUpdate
                  ? "Email address"
                  : "Or, enter multiple emails here separated by space or enter"}
              </Label>
              <div
                role="button"
                onClick={this._handleEmailInput}
                onKeyDown={this._handleEmailInput}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex="0"
                className={
                  isUpdate
                    ? "inviteteammatespopup-form-field"
                    : "inviteteammatespopup-form-field form-control focus"
                }>
                {this.state.emailArray.map((item, index) => (
                  <div className="inviteteammatespopup-tag-item" key={item}>
                    {item}
                    <Button
                      data-test="delete-email"
                      type="button"
                      className="inviteteammatespopup-button"
                      onClick={() => this._handleDelete(item, index)}>
                      &times;
                    </Button>
                  </div>
                ))}
                <input
                  data-test="add-multiple-emails"
                  id="myEmailInput"
                  className={
                    isUpdate
                      ? "form-control"
                      : "inviteteammatespopup-email-input"
                  }
                  type="text"
                  name="inviteEmail"
                  placeholder="You can enter more than one email IDs"
                  value={inviteEmail}
                  disabled={isUpdate}
                  onChange={isUpdate ? () => {} : this._onInputChange}
                  onBlur={isUpdate ? () => {} : this._checkInviteEmail}
                  onKeyDown={this._handleKeyDown}
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                />
              </div>
            </div>
            {!this.props.isInviteFromNavbar && !this.props.isInviteFromCTA && (
              <div className="inviteteammatespopup-form-field form-field-gap">
                <Label htmlFor="userRole">
                  Team members will have this User Role
                </Label>
                <ReactSelect
                  data-test="userrole-list"
                  //  autoFocus
                  valueKey="type"
                  value={userRole.label}
                  options={addValueAndLabelPropsForSelectOptions(
                    this.props.roles,
                    "name",
                  )}
                  isDisabled={this._disableRoleSection()}
                  onChange={value => this._onSelectChange("userRole", value)}
                />
              </div>
            )}

            {!this.props.isInviteFromNavbar && !this.props.isInviteFromCTA && (
              <div className="inviteteammatespopup-form-field">
                <Label htmlFor="userGroup">
                  Team members will be added to this User Group
                </Label>
                <ReactSelect
                  data-test="usergroup-list"
                  value={groupIds}
                  options={addValueAndLabelPropsForSelectOptions(
                    this.props.userGroups.filter(ug => ug.active),
                    "name",
                  )}
                  valueKey="value"
                  labelKey="label"
                  onChange={value => this._onSelectChange("groupIds", value)}
                  isMulti
                />
              </div>
            )}
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              data-test="cancel-popup-button"
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              data-test="submit-popup-button"
              className="btn btn-primary"
              onClick={
                checkTeammate && checkTeammate.is_confirmed
                  ? () => {}
                  : this._handleInviteSubmit
              }
              disabled={checkTeammate && checkTeammate.is_confirmed}
              isLoading={this.state.btnLoader}>
              {this._submitBtnText()}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { teammatesList, userGroups } = state.SettingsStore;
  return { teammatesList, userGroups };
};

const mapDispatchToProps = {
  inviteUsers: (users, flag) => inviteUsers(users, flag),
  editInviteUsers: userData => editInviteUsers(userData),
  getAllTeammatesUsers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageTeammatesPopup);



// WEBPACK FOOTER //
// ./src/components/SettingsWrapper/TeammatesSettings/ManageTeammatesPopup/index.js